import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { ChevronRight, ChevronLeft } from 'lucide-react';
import { AdminNavigation } from './AdminNavigation';
import { LogoutButton } from './LogoutButton';

type AdminSidebarProps = {
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
};

export const AdminSidebar = ({ collapsed, setCollapsed }: AdminSidebarProps) => {
  return (
    <div className={cn(
      "bg-white shadow-sm transition-all duration-300 flex flex-col",
      collapsed ? "w-16" : "w-64"
    )}>
      <div className="p-4 border-b flex items-center justify-between">
        <h1 className={cn(
          "font-bold transition-all duration-300",
          collapsed ? "text-sm" : "text-xl"
        )}>
          {collapsed ? "CS" : "CurlyScan Admin"}
        </h1>
        <Button 
          variant="ghost" 
          size="sm"
          onClick={() => setCollapsed(!collapsed)}
        >
          {collapsed ? <ChevronRight className="h-4 w-4" /> : <ChevronLeft className="h-4 w-4" />}
        </Button>
      </div>
      
      <AdminNavigation collapsed={collapsed} />
      <LogoutButton collapsed={collapsed} />
    </div>
  );
};